{
  "done": "Done",
  "notNow": "Not now",
  "dropIt": "Drop it",
  "stillMatters": "Still matters",
  "letItGo": "Let it go",
  "skip": "Skip",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "submit": "Submit",
  "addItem": "Add item",
  "startCapture": "Let's go",
  "finishOnboarding": "I'm done",
  "doneLabel": "Mark \"{{item}}\" as done",
  "stillMattersLabel": "\"{{item}}\" still matters",
  "letItGoLabel": "Let \"{{item}}\" go"
}
